/* @flow */

import * as React from 'react';

import './social-proof.module.css';

import type {SignupData} from './new-pre-auth-layout';
import signupData from './signup';

type Props = {|
    imgIndex: 0 | 1,
|};

export function SocialProof(props: Props) {
    const data: SignupData = signupData;

    const imgSrc = `/include/images/auth/social-proof-${props.imgIndex}.png`;

    return (
        <div styleName='social-proof-container'>
            <div styleName='header'>{data.reviewSectionTitle}</div>
            <img src={imgSrc} alt='social proof' styleName='social-proof-image' />
        </div>
    );
}
